import { ReactNode, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import { Progress, ProgressContext, ProgressOptions } from './useProgress.js';
import { getStepIndexFromRoute } from './utils.js';

export default function ProgressProvider({ children }: { children: ReactNode }): JSX.Element {
  const location = useLocation();
  const [progress, setProgress] = useState<Progress>(null);
  const [options, setOptions] = useState<ProgressOptions>(null);

  const value = useMemo(
    () => ({
      currentStep: getStepIndexFromRoute(location.pathname, progress?.steps),
      options,
      progress,
      setOptions,
      setProgress,
    }),
    [options, location, progress],
  );

  return <ProgressContext.Provider value={value}>{children}</ProgressContext.Provider>;
}
